import { scrollIntoView } from 'ia-react-core';
import React, { FC, useCallback, MouseEvent } from 'react';
import { TableOfContents } from '../../../../../interfaces/TableOfContents';
import { StyledDiv, StyledLi, StyledLink, StyledUl } from './ContentTable.styles';
import { Items } from '../../../../../interfaces/Items';

export interface ContentTableProps {
  data: TableOfContents;
  tableOfContentName: string;
}

const ContentTable: FC<ContentTableProps> = ({ data, tableOfContentName }) => {
  const handleClick = useCallback((t: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.querySelector(t);
    scrollIntoView(target as HTMLElement);
  }, []);

  const renderListItem = (isSubItem: boolean, item: Items, index: number) => {
    const itemId = item.name.replace(/[0-9.\s]/g, '');
    const onClickHandler = (event: MouseEvent<HTMLAnchorElement>) => handleClick(`#${itemId}`)(event);

    return (
      <StyledLi isSubItem={isSubItem} key={index}>
        <StyledLink
          onClick={onClickHandler}
          href={`${window.location.pathname}${window.location.search}#${itemId}`}
        >
          <StyledDiv>{item.fields.title}</StyledDiv>
        </StyledLink>
      </StyledLi>
    );
  };

  return (
    <StyledUl isTermsOfUse={tableOfContentName === 'terms'} id="contentTable">
      {data.items.map((item, index) => (
        <React.Fragment key={index}>
          {renderListItem(false, item, index)}
          {item.fields?.items?.map((subItem) =>
            renderListItem(true, subItem, index))}
        </React.Fragment>
      ))}
    </StyledUl>
  );
};

export default ContentTable;
